import {
  deletePromptFile,
  uploadPromptFile,
} from '@/data/services/promptInstructionServices';
import { AstroFile } from '@/models/AstroFile';
import { PromptFile } from '@/models/PromptInstruction';

const segregateToCreateAndDelete = (
  currentFiles: PromptFile[],
  localFiles: AstroFile[],
) => {
  const filesToUpload = localFiles.filter(astroFile =>
    astroFile.fileKey.startsWith('local-'),
  );

  const localFileKeys = localFiles.map(f => f.fileKey);

  const filesToDelete = currentFiles.filter(
    serverFile => !localFileKeys.includes(mountFileKey(serverFile)),
  );

  return {
    filesToUpload,
    filesToDelete,
  };
};

type SyncFilesArgs = {
  currentFiles: PromptFile[];
  localFiles: AstroFile[];
  promptId: number;
};

export const syncFilesWithBackend = async ({
  currentFiles,
  localFiles,
  promptId,
}: SyncFilesArgs) => {
  const { filesToUpload, filesToDelete } = segregateToCreateAndDelete(
    currentFiles,
    localFiles,
  );

  const uploadPromises = filesToUpload.map(astroFile => {
    if (astroFile.file instanceof File) {
      return uploadPromptFile(promptId, astroFile.file);
    }
    return Promise.resolve();
  });

  const deletePromises = filesToDelete.map(file =>
    deletePromptFile(promptId, file.id),
  );

  await Promise.all([...uploadPromises, ...deletePromises]);
};

export const adapterPromptFileToAstroFile = (
  promptFile: PromptFile,
): AstroFile => {
  return {
    file: promptFile.file,
    fileName: promptFile.fileName,
    fileKey: mountFileKey(promptFile),
    createdAt: promptFile.createdAt,
  };
};

export const mountFileKey = (promptFile: PromptFile) => {
  return `server-${promptFile.id}`;
};
